<script>
  import BillsList from '@/BillsList';
  
  export default {
    name: 'ProjectBillsList',
    extends: BillsList,
    data() {
      return {
        visibleColumns: this.getVisibleColumns() || ['number', 'status', 'amount', 'paid_amount', 'comment', 'valid_until', 'edit'],
        filter: `filter[project_id]=${this.$route.params.id}`,
      }
    }
  };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ProjectBillsList/ProjectBillsList.vue